import React from 'react';
import { AnalyticsEvents } from '../../../../components/analytics/analyticsEvents';
import CustomConfiguration from './CustomConfiguration';
import HiltiServiceVanConfiguration from './HiltiServiceVanConfiguration';
import { HiltiCustomConfigurationKey, HiltiCustomConfigurationName } from './CustomConfigurationStatus';

export const CustomConfigurations: React.FC = () => (
  <>
    <HiltiServiceVanConfiguration />
    <CustomConfiguration
      configurationKey={HiltiCustomConfigurationKey.HEAVY_MACHINE}
      configurationName={HiltiCustomConfigurationName.HEAVY_MACHINE}
      analyticsEvent={AnalyticsEvents.HiltiBleScanningConfiguration}
    />
  </>
);

export default CustomConfigurations;
